import type { UserRole } from 'types/api';

const origin = window.location.origin;

export const API_URL =
  process.env.NODE_ENV === 'development' ? `${origin}/devapi` : `${origin}/api`;

export const ROLES: UserRole[] = ['radnik', 'qa', 'admin', 'superadmin'];

export const WORKPLACES: Record<string, string> = {
  'dugi-rat': 'Dugi Rat',
  sinj: 'Sinj',
};

export const CONTRACT: Record<string, string> = {
  partTime: 'Određeno',
  fullTime: 'Neodređeno',
};
